import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("xsquad_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d);
}

export const FALLBACK_PRODUCT = {
  name: "Project X Make Parties Great Again Hat",
  edition: "Party Lyfe Edition",
  description:
    "Project X Make Parties Great Again Hats! High Quality Material! This here is the latest updated and this one will last you your whole PARTY LYFE! FREE Shipping!",
  price: 30,
  shipping: 0,
  stock: 100,
  colorway: "Red / White",
};

export const money = (n) => `$${Number(n ?? 0).toFixed(2)}`;

export const shipText = (n) => (Number(n ?? 0) > 0 ? money(n) : "FREE");
